import type { SlideInAction } from '@/types/internal/frappeActionTypes.ts'

import { RelationGroupType } from '@/constants/relations.ts'

type DoctypeCreateSlideInConfig = Omit<SlideInAction, 'type'>

/**
 * Doctype-keyed slide-in configs, shared by `frappeInterceptNewCreateActionMap`
 * and the bulk edit route interception in `FrappeComponentIFrameWrapper`.
 */
const doctypeCreateSlideInMap = {
  Contact: {
    relationGroupType: RelationGroupType.persons,
  },
  Customer: {
    organizationRelationType: 'Customer',
    relationGroupType: RelationGroupType.organizations,
  },
  'Sales Partner': {
    organizationRelationType: 'Sales Partner',
    relationGroupType: RelationGroupType.organizations,
  },
  Supplier: {
    organizationRelationType: 'Supplier',
    relationGroupType: RelationGroupType.organizations,
  },
} satisfies Record<string, DoctypeCreateSlideInConfig>

const doctypeCreateSlideInLookup: Record<string, DoctypeCreateSlideInConfig> =
  doctypeCreateSlideInMap

const getDoctypeCreateSlideInConfig = (doctype: string): DoctypeCreateSlideInConfig | undefined => {
  return doctypeCreateSlideInLookup[doctype]
}

export { type DoctypeCreateSlideInConfig, doctypeCreateSlideInMap, getDoctypeCreateSlideInConfig }
